module.exports = __webpack_public_path__ + "img/ctrl-swap-stub-mid--i.d30002d5.svg";